import { render, staticRenderFns } from "./begintime.vue?vue&type=template&id=30790068&scoped=true"
import script from "./begintime.vue?vue&type=script&lang=js"
export * from "./begintime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30790068",
  null
  
)

export default component.exports